import axios from "axios";
import { API } from "@/lib/api";

const KEY = "escola_token";

export const getEscolaToken = () => localStorage.getItem(KEY);
export const setEscolaToken = (t) => localStorage.setItem(KEY, t);
export const clearEscolaToken = () => localStorage.removeItem(KEY);

export const escolaApi = axios.create({ baseURL: API });
escolaApi.interceptors.request.use((cfg) => {
  const t = getEscolaToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const certificateUrl = () => `${API}/escola/certificate/pdf?auth=${getEscolaToken()}`;
